<script lang="ts">
  import { DEFAULT_TOOLTIP_CLASSES, tooltip } from "app/actions/tooltip";
  import { onMount } from "svelte";
  import type { Placement } from "tippy.js";

  export let interactive = false;
  export let headless = false;
  export let appendToBody = false;
  export let clickToTrigger = false;
  export let placement: Placement = "top";

  let tip: HTMLDivElement;

  onMount(() => {
    // only reveal element after render when tippy has moved it
    // Sometimes tip doesn't exist yet. Not sure why
    if (tip) {
      tip.style.display = "block";
    }
  });
</script>

<span
  use:tooltip={{
    element: tip,
    interactive,
    interactiveDebounce: 75,
    interactiveBorder: 30,
    trigger: clickToTrigger ? "click" : "mouseenter focus",
    hideOnClick: true,
    appendTo: appendToBody ? () => document.body : undefined,
    placement,
  }}
  class="grid shrink-0"
>
  <slot />
</span>

<div bind:this={tip} class="hidden">
  <span class={headless ? "" : DEFAULT_TOOLTIP_CLASSES}>
    <slot name="tip" />
  </span>
</div>
